import React, { useState, useEffect } from "react";
import { Switch, Checkbox, Row, Col, Collapse, Radio, Form } from "antd";
// style
import styles from "./form.module.css";

const { Panel } = Collapse;

const SettingsForm = ({
  disabledState,
  getFieldValue,
  setFieldsValue
}) => {
  const [solutionAccess, setSolutionAccess] = useState(
    getFieldValue("settings_app_solution_access"),
  );
  const [outOfOffice, setOutOfOffice] = useState(
    getFieldValue("settings_app_out_of_office"),
  );

  useEffect(() => {
    setSolutionAccess(getFieldValue("settings_app_solution_access"));
  }, [getFieldValue("settings_app_solution_access")]);

  useEffect(() => {
    setOutOfOffice(getFieldValue("settings_app_out_of_office"));
  }, [getFieldValue("settings_app_out_of_office")]);

  const settingsAppOutOfOfficeOnChange = (e) => {
    setOutOfOffice((prevState) => !prevState);
    if (e.target.checked) {
      setFieldsValue({ settings_app_out_of_office: true });
    } else {
      setFieldsValue({
        settings_app_out_of_office_to_other_signers: false,
        settings_app_out_of_office_to_other_signers_edit: false,
        settings_app_out_of_office: false,
      });
    }
  };
  const solutionAccessOnChange = (value) => {
    setSolutionAccess((prevState) => !prevState);
    setFieldsValue({ settings_app_solution_access: value });
  };
  return (
    <Collapse defaultActiveKey={["settings_app_1"]} expandIconPosition="end">
      <Panel header="Settings" key="settings_app_1">
        <div className="is_form_2_a">
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Solution Access</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Form.Item
                  style={{
                    borderBottom: "none",
                  }}
                  name="settings_app_solution_access"
                  valuePropName="checked"
                >
                  <Switch
                    disabled={disabledState}
                    onChange={solutionAccessOnChange}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Grant Access</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={3} xl={4} lg={4} sm={8}>
                    <Form.Item
                      noStyle
                      name="settings_app_grant_access"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("settings_app_solution_access")
                        }
                      >
                        Access
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Manage Group</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="settings_app_manage_groups"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("settings_app_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Manage Signature</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6} xs={24}>
                    <Form.Item
                      noStyle
                      name="settings_app_manage_signature"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("settings_app_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xxl={4} xl={6} lg={8} sm={12} xs={24}>
                    <Form.Item
                      noStyle
                      name="settings_app_show_report_category"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("settings_app_solution_access")
                        }
                      >
                        Show Report Category
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Manage CC Recipients</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="settings_app_manage_cc_recipients"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("settings_app_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Out of Office</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6} xs={24}>
                    <Form.Item
                      noStyle
                      name="settings_app_out_of_office"
                      valuePropName="checked"
                    >
                      <Checkbox
                        onChange={settingsAppOutOfOfficeOnChange}
                        disabled={
                          disabledState ||
                          !getFieldValue("settings_app_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col xxl={4} xl={6} lg={8} sm={12} xs={24}>
                    <Form.Item
                      noStyle
                      name="settings_app_out_of_office_to_other_signers"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("settings_app_solution_access") ||
                          !outOfOffice
                        }
                      >
                        To Other Signers
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col xxl={4} xl={6} lg={8} sm={12} xs={24}>
                    <Form.Item
                      noStyle
                      name="settings_app_out_of_office_to_other_signers_edit"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("settings_app_solution_access") ||
                          !outOfOffice
                        }
                      >
                        To Other Signers Edit
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Update Envelope</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="settings_app_post_envelope"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("settings_app_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="is_form_2_aa">
            <Row>
              <Col
                xxl={3}
                xl={4}
                lg={5}
                md={5}
                sm={5}
                xs={24}
                className={styles.label}
              >
                <label>Daily Recap</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Row>
                  <Col xxl={2} xl={3} lg={4} sm={6}>
                    <Form.Item
                      style={{
                        borderBottom: "none",
                      }}
                      name="settings_app_daily_recap"
                      valuePropName="checked"
                    >
                      <Checkbox
                        disabled={
                          disabledState ||
                          !getFieldValue("settings_app_solution_access")
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </Panel>
    </Collapse>
  );
};

export default SettingsForm;
